import React from 'react';

const CancelIcon = (props) => {
    return (
        <svg className="fill-current" style={{cursor:"pointer"}} id="Capa_1" enableBackground="new 0 0 551.13 551.13" height="20px" viewBox="0 0 551.13 551.13" width="20px" xmlns="http://www.w3.org/2000/svg"><path d="m275.565 0c-151.944 0-275.565 123.621-275.565 275.565s123.621 275.565 275.565 275.565 275.565-123.621 275.565-275.565-123.621-275.565-275.565-275.565zm0 516.685c-132.955 0-241.119-108.164-241.119-241.119s108.164-241.12 241.119-241.12 241.12 108.164 241.12 241.119-108.165 241.12-241.12 241.12z"/><path d="m360.821 165.955-85.256 85.256-85.256-85.256-24.354 24.354 85.256 85.256-85.256 85.256 24.354 24.354 85.256-85.256 85.256 85.256 24.354-24.354-85.256-85.256 85.256-85.256z"/></svg>
    );
};

export default CancelIcon;

